<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
  >
    <!-- <v-app-bar-nav-icon -->
    <!--   v-if="!isDrawerHidden" -->
    <!--   @click.stop="$store.commit('toggleDrawer', !$store.state.drawer)" -->
    <!-- /> -->

		<a href="https://www.pickaservice.ky/">
			<img
				src="@/assets/logo.png"
				align-center
				justify-center
				width="50px"
			/>
		</a>

		<v-btn href="https://www.pickaservice.ky/" class="ml-2" color="white"
			text flat v-if="showHome">
			<v-icon>mdi-home</v-icon>
		</v-btn>
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4"
			>{{ this.$route.meta.title || 'Pickaservice' }}</v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-divider vertical></v-divider>
    <v-btn v-if="isAuthenticated" icon @click.stop="logOut">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',

  props: {
    isDrawerHidden: Boolean,
		showHome: Boolean,
  },

  computed: {
    isAuthenticated: function () {
      return !!this.$store.state.authToken
    },
  },

  methods: {
    logOut: function () {
      this.$store.dispatch("removeAuthToken")
      this.$router.go()
    }
  }
};
</script>
